import { render } from "./QuoteDocument.vue?vue&type=template&id=398f7406"
import script from "./QuoteDocument.vue?vue&type=script&lang=js"
export * from "./QuoteDocument.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__